module.exports = "https://infinity-call.servercdn.it/static/fonts/FuturaPT-Demi.woff?65ee0094094ad87a468482025e755626";